import { CheckCircle, QueryStats, Warning } from "@mui/icons-material";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { documentNumberFormatter, formatMoney } from "../../../../services/UtilsService";

const statusIcon = {
  ACCEPTED: <CheckCircle sx={{ color: "#269800" }} />,
  REJECTED: <Warning sx={{ color: "#E71D36" }} />,
  ANTICIPATED: <QueryStats sx={{ color: "#FF8500" }} />,
};

const status = {
  ACCEPTED: "Aprovado",
  REJECTED: "Rejeitado",
  ANTICIPATED: "Antecipado",
};

const InvoiceDetails = ({ receivable }) => {
  return (
    <>
      <Grid container padding={"20px 0px"}>
        <Grid container item xs={3} rowSpacing={0.5}>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: 14,
                color: "#575757",
              }}
              color="inherit"
              noWrap
            >
              Número da NF-e
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: 16,
                color: "#00010C",
              }}
              noWrap
            >
              {`${receivable.notaFiscal.number}-${receivable.notaFiscal.serie}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box display={"flex"}>
              {statusIcon[receivable.simulationStatus]}
              <Typography
                sx={{
                  marginLeft: "8px",
                  fontWeight: 400,
                  fontSize: 14,
                  color: "#575757",
                }}
                color="inherit"
                noWrap
              >
                {status[receivable.simulationStatus]}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
        <Grid container item xs={6} rowSpacing={0.5} paddingLeft={2}>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: 14,
                color: "#575757",
              }}
              color="inherit"
              noWrap
            >
              Destinatário
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: 16,
                color: "#00010C",
              }}
              noWrap
            >
              {receivable.notaFiscal.tomador.name}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: 16,
                color: "#575757",
              }}
              noWrap
            >
              {documentNumberFormatter(receivable.notaFiscal.tomador.documentNumber)}
            </Typography>
          </Grid>
        </Grid>
        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
        <Grid container item xs={3} rowSpacing={0.5}>
          <Grid item xs={12}>
            <Typography
              align="right"
              sx={{
                fontWeight: 400,
                fontSize: 14,
                color: "#575757",
              }}
              color="inherit"
            >
              Valor da nota
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              align="right"
              sx={{
                fontWeight: 400,
                fontSize: 16,
                color: "#00010C",
              }}
              noWrap
            >
              {formatMoney(receivable.notaFiscal.totalAmount)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              align="right"
              sx={{
                fontWeight: 400,
                fontSize: 14,
                color: "#575757",
              }}
              color="inherit"
              noWrap
            >
              {`${
                receivable.notaFiscal.bill.numberOfInstallments
              }x de ${formatMoney(
                receivable.notaFiscal.bill.installmentAverageAmount
              )}`}
            </Typography>
          </Grid>
        </Grid>
        {receivable.simulationStatusDescription && (
          <Grid item xs={12} marginTop={1}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: 14,
                color: "#E71D36",
              }}
              color="inherit"
              noWrap
            >
              {receivable.simulationStatusDescription}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Divider />
    </>
  );
};

export default InvoiceDetails;
